import gql from "graphql-tag"
import type { TypedDocumentNode } from "@graphql-typed-document-node/core"

type OrderOperationEvent = {
  orderId: string
  type: string
}

type OnOrderOperationCompletedSubscription = { OnOrderOperationCompleted: OrderOperationEvent }

const ON_ORDER_OPERATION_COMPLETED: TypedDocumentNode<
  OnOrderOperationCompletedSubscription,
  Record<string, never>
> = gql`
  subscription OnOrderOperationCompleted {
    OnOrderOperationCompleted {
      orderId
      type
    }
  }
`

export default ON_ORDER_OPERATION_COMPLETED
